/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { filter, isEmpty, map, concat, each } from 'lodash'
import React, { useEffect, useReducer } from 'react'
import Dropzone from 'react-dropzone'

const Attachments = ({
  report,
  setReport,
  canEdit
}) => {
  const [attachments, updateAttachments] = useReducer((state, event) => {
    if (event.action === 'delete') {
      const files = filter(state, attachment => attachment !== event.file)
      report.attachments = files
      if (event.file.id) { report.attachmentsToRemove.push({ id: event.file.id }) }
    } else {
      report.attachments = concat(...state, event.file)
    }

    setReport(report)
    return report.attachments
  }, [])

  useEffect(() => {
    if (isEmpty(attachments)) {
      each(report.attachments, file => updateAttachments({ file }))
    }
  }, [report.attachments])

  return (
    <div>
      {canEdit && (
        <div className="flex mt-2">
          <Dropzone className="dropzone" onDrop={file => updateAttachments({ action: 'add', file })}>
            <span className="link">
              Attach files
            </span>
          </Dropzone>
          <small>
            (limit 5MB)
          </small>
        </div>
      )}
      {!isEmpty(attachments) && (
        <ul>
          <hr className="mt-2 mb-2" />
          {map(attachments, attachment => (
            <li>
              <a href={attachment.preview} target="_blank" rel="noopener noreferrer">
                {attachment.name}
              </a>
              {canEdit && (
                <span
                  className="lnr lnr-trash2 text-red-500 hover:text-red-700 cursor-pointer ml-2"
                  onClick={() => updateAttachments({ action: 'delete', file: attachment })}
                />
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default Attachments
